import { c as _c } from "react/compiler-runtime";
import React from "react";
interface CloseIconProps {
  size?: number;
  className?: string;
}
const CloseIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const t2 = `dynamic-size ${className}`;
  let t3;
  if ($[0] !== size) {
    t3 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as React.CSSProperties;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M10.5858 11.9999L4.22183 5.63589L5.63605 4.22168L12 10.5856L18.364 4.22168L19.7782 5.63589L13.4142 11.9999L19.7782 18.3638L18.364 19.778L12 13.4141L5.63605 19.778L4.22183 18.3638L10.5858 11.9999Z" fill="currentColor" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t2 || $[4] !== t4) {
    t6 = <svg className={t2} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" style={t4}>{t5}</svg>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export default CloseIcon;